import { Button } from '@chakra-ui/react';
import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAccount, useChainId, useSwitchChain } from 'wagmi';
import { Modal } from '@/components/Elements/';
import { network } from '@/constants/network';

export const NetworkValidationLayout: FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation('common');
  const { isConnected } = useAccount();
  const chainId = useChainId();
  const [error, setError] = useState<{ title: string; description: string }>({
    title: '',
    description: '',
  });
  const [isOpen, setIsOpen] = useState(false);
  const { switchChain, isPending } = useSwitchChain();

  useEffect(() => {
    if (!isConnected) {
      return;
    }

    if (chainId !== network.chainId) {
      setError({
        title: t('common.components.layouts.networkValidation.wrongNetwork.title'),
        description: t('common.components.layouts.networkValidation.wrongNetwork.description'),
      });
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [isConnected, chainId, t]);

  const NetworkIcon = network.icon;

  return (
    <>
      {children}
      <Modal title={error.title} description={error.description} isOpen={isOpen}>
        <Button
          mt={4}
          w="100%"
          onClick={() => switchChain?.({ chainId: network.chainId })}
          loading={isPending}
          gap={2}
        >
          <NetworkIcon boxSize={5} />
          {network.name}
        </Button>
      </Modal>
    </>
  );
};
